var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded shadow-sm",class:_vm.backgroundClass,style:({ backgroundColor: _vm.color })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }